import styled from 'styled-components';

const StyledRepositoryItemActions = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: ${props => (props.isCampaign ? '2.5rem' : '4rem')};
  padding: 0 ${props => props.theme.spacing.small};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  visibility: hidden;
  opacity: 0;
`;

export { StyledRepositoryItemActions };
